import React from 'react';

import { useTournamentState } from '@atlas/core';
import { MarketTypesSelectorSkeleton } from '@atlas/ui';

const MarketTypesSelectorLoader = ({ children }) => {
  const { initialized, loading } = useTournamentState();

  if (!initialized && loading) {
    return (
      <div className="market-type-selector-skeleton">
        <MarketTypesSelectorSkeleton />
      </div>
    );
  }

  return children;
};

export default MarketTypesSelectorLoader;
